module.exports = __webpack_public_path__ + "static/img/coupon-txt.8a732dc.png";